import React, { useCallback, useEffect } from 'react'
import Dropdown from '@groovehq/internal-design-system/lib/components/Dropdown/Dropdown'
import Scroller from 'components/Scroller'
import KeyboardNavigator from 'components/KeyboardNavigator'
import { propFunc } from 'util/functions'
import RecipientItem from './RecipientItem'

const DropdownMenu = ({
  lastFilteredSize,
  onSelect,
  recipients,
  activatedRecipientIdRef,
}) => {
  const handleActivate = useCallback(
    id => {
      // eslint-disable-next-line no-param-reassign
      activatedRecipientIdRef.current = id
    },
    [activatedRecipientIdRef]
  )

  useEffect(
    () => {
      // eslint-disable-next-line no-param-reassign
      activatedRecipientIdRef.current = recipients[0]?.id
    },
    [activatedRecipientIdRef, recipients]
  )

  if (!recipients || lastFilteredSize === 0) {
    return null
  }

  return (
    <Dropdown.Menu>
      <Scroller>
        {recipients.map(r => (
          <Dropdown.Menu.Item
            key={r.id}
            itemKey={r.id}
            item={r}
            as={KeyboardNavigator.Item}
            activeClassName="highlighted"
            activeClassNameOverridden
            // Click handler
            onSelect={onSelect}
            onActivate={propFunc(handleActivate, r.id)}
          >
            <RecipientItem recipient={r} />
          </Dropdown.Menu.Item>
        ))}
      </Scroller>
    </Dropdown.Menu>
  )
}

export default DropdownMenu
